import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import {
  AdminBenutzer,
  AdminBenutzerCreate,
  AdminKostenstelle,
  PayloadAdminBenutzer,
  PayloadAdminBenutzerCreate,
  PayloadAdminBenutzerList,
  PayloadAdminKostenstelle,
  PayloadAdminKostenstelleList,
  PayloadBoolean,
  PayloadGroupList, PayloadIntranetUser,
  PayloadIntranetUserList,
  PayloadRightList
} from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestAdminService extends RestService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  getGroups(): Observable<PayloadGroupList> {
    return this.http
      .get<PayloadGroupList>(this.baseUrl + '/admin/group', this.httpOptions);
  }

  public getAllBenutzer(): Observable<PayloadAdminBenutzerList> {
    return this.http
      .get<PayloadAdminBenutzerList>(this.baseUrl + '/admin/benutzer', this.httpOptions);
  }

  public getBenutzer(userid: string): Observable<PayloadAdminBenutzer> {
    return this.http
      .get<PayloadAdminBenutzer>(this.baseUrl + '/admin/benutzer/' + userid, this.httpOptions);
  }

  public saveBenutzer(adminBenutzer: AdminBenutzer): Observable<PayloadBoolean> {
    return this.http
      .put<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + adminBenutzer.userid,
        adminBenutzer,
        this.httpOptions);
  }

  public saveBenutzerRights(adminBenutzer: AdminBenutzer): Observable<PayloadBoolean> {
    return this.http
      .put<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + adminBenutzer.userid + '/rights',
        adminBenutzer,
        this.httpOptions);
  }

  public getAllRights(): Observable<PayloadRightList> {
    return this.http
      .get<PayloadRightList>(this.baseUrl + '/admin/rights', this.httpOptions);
  }

  public getBenutzerCreate(): Observable<PayloadAdminBenutzerCreate> {
    return this.http
      .get<PayloadAdminBenutzerCreate>(
        this.baseUrl + '/admin/benutzer/create',
        this.httpOptions);
  }

  public getBenutzerEdit(userid: string): Observable<PayloadAdminBenutzerCreate> {
    return this.http
      .get<PayloadAdminBenutzerCreate>(
        this.baseUrl + '/admin/benutzer/' + userid + '/edit',
        this.httpOptions);
  }

  public createBenutzer(adminBenutzerCreate: AdminBenutzerCreate): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + adminBenutzerCreate.userid + '/create',
        adminBenutzerCreate,
        this.httpOptions);
  }

  public updateBenutzer(userid: string, adminBenutzerCreate: AdminBenutzerCreate): Observable<PayloadBoolean> {
    return this.http
      .put<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + userid + '/update',
        adminBenutzerCreate,
        this.httpOptions);
  }

  public disableBenutzer(adminBenutzerCreate: AdminBenutzerCreate): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + adminBenutzerCreate.userid + '/disable',
        adminBenutzerCreate,
        this.httpOptions);
  }

  public createArchivBenutzer(adminBenutzerCreate: AdminBenutzerCreate): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + adminBenutzerCreate.userid + '/archiv',
        adminBenutzerCreate,
        this.httpOptions);
  }

  public getArchivExists(userid: string): Observable<PayloadBoolean> {
    return this.http
      .get<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + userid + '/archiv/exists',
        this.httpOptions);
  }

  public disableArchiv(adminBenutzerCreate: AdminBenutzerCreate): Observable<PayloadBoolean> {
    return this.http
      .put<PayloadBoolean>(
        this.baseUrl + '/admin/benutzer/' + adminBenutzerCreate.userid + '/archiv/disable',
        adminBenutzerCreate,
        this.httpOptions);
  }

  public getKostenstellen(): Observable<PayloadAdminKostenstelleList> {
    return this.http
      .get<PayloadAdminKostenstelleList>(
        this.baseUrl + '/admin/kostenstellen',
        this.httpOptions);
  }

  public editKostenstelle(body: AdminKostenstelle): Observable<PayloadBoolean> {
    return this.http
      .put<PayloadBoolean>(
        this.baseUrl + '/admin/kostenstellen', body,
        this.httpOptions);
  }

  public createKostenstelle(body: AdminKostenstelle): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/admin/kostenstellen', body,
        this.httpOptions);
  }

  public getKostenstelle(kostNr: string): Observable<PayloadAdminKostenstelle> {
    return this.http
      .get<PayloadAdminKostenstelle>(
        this.baseUrl + '/admin/kostenstellen/' + kostNr,
        this.httpOptions);
  }

  public deleteKostenstelle(kostNr: string): Observable<PayloadBoolean> {
    return this.http
      .delete<PayloadBoolean>(
        this.baseUrl + '/admin/kostenstellen/' + kostNr,
        this.httpOptions);
  }

  public getAllIntranetUser(): Observable<PayloadIntranetUserList> {
    return this.http
      .get<PayloadIntranetUserList>(
        this.baseUrl + '/admin/findAll',
        this.httpOptions);
  }

  public updateIntranetUser(body: PayloadIntranetUser, userid: string): Observable<PayloadIntranetUser> {
    return this.http
      .put<PayloadIntranetUser>(
        this.baseUrl + '/admin/update/' + userid, body,
        this.httpOptions);
  }

  public createIntranetUser(body: PayloadIntranetUser): Observable<PayloadIntranetUser> {
    return this.http
      .post<PayloadIntranetUser>(
        this.baseUrl + '/admin/create', body,
        this.httpOptions);
  }

  public getIntranetUserById(userid: string): Observable<PayloadIntranetUser> {
    return this.http
      .get<PayloadIntranetUser>(
        this.baseUrl + '/admin/findByUserId/' + userid,
        this.httpOptions);
  }

  public deleteIntranetUser(userid: string): Observable<PayloadIntranetUser> {
    return this.http
      .delete<PayloadIntranetUser>(
        this.baseUrl + '/admin/delete/' + userid,
        this.httpOptions);
  }

}
